import React from 'react';
import  AvidReader2025  from 'views/AvidReader2025';

const DesktopAppPage = () => {
  return <AvidReader2025/>;
};
export default DesktopAppPage;
